var _excluded = ["children", "className", "component", "count", "href", "onClick", "onKeyDown", "target", "level"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef } from "react";
import { keyCodes } from "../../utils/helpers";
import "./ATag.scss";
var ATag = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    propsClassName = _ref.className,
    component = _ref.component,
    _ref$count = _ref.count,
    count = _ref$count === void 0 ? false : _ref$count,
    href = _ref.href,
    onClick = _ref.onClick,
    _onKeyDown = _ref.onKeyDown,
    target = _ref.target,
    level = _ref.level,
    rest = _objectWithoutProperties(_ref, _excluded);
  var className = "a-tag focus-box-shadow";
  if (href || onClick) {
    className += " interactable";
  }
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  if (count) {
    className += " a-tag--count";
  }
  if (level) {
    className += " a-tag--state-".concat(level);
  }
  var TagName = "div";
  var props = _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    className: className,
    onClick: onClick,
    onKeyDown: function onKeyDown(e) {
      if (!href && onClick && [keyCodes.enter].includes(e.keyCode)) {
        e.preventDefault();
        onClick(e);
      } else {
        _onKeyDown && _onKeyDown(e);
      }
    }
  });
  if (href) {
    TagName = "a";
    props.href = href;
    props.target = target;
  }
  if (onClick) {
    props.role = "button";
  }
  if (href || onClick || component) {
    props.tabIndex = 0;
  }
  if (component) {
    TagName = component;
  }
  return /*#__PURE__*/React.createElement(TagName, props, children);
});
ATag.propTypes = {
  /**
   * Sets the base component. Useful for integrating with routers.
   */
  component: PropTypes.elementType,
  /**
   * Indicates if the data should represent a count - more rounded
   */
  count: PropTypes.bool,
  /**
   * If specified, the component will render as an HTML link.
   */
  href: PropTypes.string,
  /**
   * If the `href` property is defined, the target can be set (ex: `_blank`, `_self`, `_parent`, `_top`)
   */
  target: PropTypes.string,
  /**
   * Specifies the display variant.
   */
  level: PropTypes.oneOf(["info", "information", "positive", "warning", "negative"])
};
ATag.displayName = "ATag";
export default ATag;